<div class="flex flex-col gap-4">
  <app-input
    [formControl]="form.controls.title"
    [label]="'crm_tasks.fields.title' | translate"
    [required]="true"
    [maxlength]="titleMaxLength"
  />

  <app-textarea [formControl]="form.controls.description" [label]="'crm_tasks.fields.description' | translate" />

  <app-select
    [formControl]="form.controls.assignee_id"
    [options]="assigneeOptions"
    optionLabel="name"
    optionValue="id"
    [isAvatar]="true"
    [filter]="true"
    [required]="true"
    [label]="'crm_tasks.fields.assignee' | translate"
  />

  <div class="flex flex-col gap-2">
    <span class="text-xs">{{ 'crm_tasks.fields.observers' | translate }}</span>
    @if (observers.length) {
      <div class="flex flex-wrap gap-1.5">
        @for (observer of observers; track observer.id) {
          <span
            class="inline-flex max-w-full items-center gap-1.5 rounded-full bg-slate-100 py-0.5 pl-1 pr-1 text-sm font-medium text-slate-700"
          >
            <app-task-user class="min-w-0" size="22px" [user]="observer" />
            <button
              type="button"
              class="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-slate-400 hover:bg-rose-50 hover:text-rose-600"
              [attr.aria-label]="'delete' | translate"
              (click)="removeObserver(observer.id)"
            >
              <app-icon class="!h-3.5 !w-3.5 !text-[14px] !leading-none">close</app-icon>
            </button>
          </span>
        }
      </div>
    }
    <app-select
      [formControl]="observerPicker"
      [options]="observerOptions"
      optionLabel="name"
      optionValue="id"
      [isAvatar]="true"
      [filter]="true"
      [placeholder]="'crm_tasks.fields.add_observer' | translate"
    />
  </div>

  <div class="flex flex-col gap-1">
    <span class="text-xs">{{ 'crm_tasks.fields.deadline' | translate }}</span>
    <div class="flex items-center gap-2">
      <p-datepicker
        class="min-w-0 flex-1"
        [fluid]="true"
        dataType="string"
        dateFormat="yy-mm-dd"
        [showButtonBar]="true"
        appendTo="body"
        panelStyleClass="board-v3-datepicker-panel"
        inputStyleClass="h-10 w-full rounded-lg border !border-slate-200 bg-white px-3 text-sm text-slate-800 outline-none focus:!border-orange-400"
        [placeholder]="'date' | translate"
        [ariaLabel]="'date' | translate"
        [formControl]="form.controls.deadline_date"
      />
      <p-datepicker
        class="w-28 shrink-0"
        dataType="string"
        [timeOnly]="true"
        hourFormat="24"
        [stepMinute]="1"
        appendTo="body"
        panelStyleClass="board-v3-datepicker-panel"
        inputStyleClass="h-10 w-full rounded-lg border !border-slate-200 bg-white px-3 text-sm text-slate-800 outline-none focus:!border-orange-400 disabled:cursor-not-allowed disabled:bg-slate-50"
        [placeholder]="'time_label' | translate"
        [ariaLabel]="'time_label' | translate"
        [formControl]="form.controls.deadline_time"
      />
    </div>
    <p class="!m-0 text-xs leading-5 text-slate-400">{{ 'crm_tasks.fields.deadline_hint' | translate }}</p>
  </div>

  <app-select
    [formControl]="form.controls.priority"
    [options]="priorityOptions"
    optionLabel="label"
    optionValue="value"
    [isTranslate]="true"
    [label]="'crm_tasks.fields.priority' | translate"
  />

  <div class="flex items-start gap-3 rounded-lg bg-slate-50 px-3 py-2.5">
    <p-toggleswitch
      class="mt-0.5 shrink-0"
      [inputId]="'task-requires-review-' + uid"
      [formControl]="form.controls.requires_review"
    />
    <label class="m-0 min-w-0 flex-1 cursor-pointer" [for]="'task-requires-review-' + uid">
      <span class="block text-sm font-medium text-slate-800">{{ 'crm_tasks.fields.requires_review' | translate }}</span>
      <span class="block text-xs leading-5 text-slate-500">{{
        'crm_tasks.fields.requires_review_hint' | translate
      }}</span>
    </label>
  </div>

  @if (canLink) {
    <div class="flex flex-col gap-1">
      <span class="text-xs">{{ 'crm_tasks.fields.links' | translate }}</span>
      <app-task-links
        [formControl]="form.controls.links"
        [openable]="openableLinks"
        [canOpenCards]="canOpenCards"
        (openLink)="openLink.emit($event)"
      />
    </div>
  }
</div>
